module.exports = __webpack_public_path__ + "img/nespresso_banner.9df173f.png";